module.exports = __webpack_public_path__ + "media/images/fondo-ab5c494c7974986409228e15c9d6c54a.jpg";